import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Link, 
  Divider,
  IconButton,
  Stack
} from '@mui/material';
import { 
  Facebook as FacebookIcon,
  SupportAgent as SupportAgentIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const openHelp = () => document.dispatchEvent(new Event('krillou:open-help'));

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <Box component="footer" sx={{ bgcolor: 'black', color: 'white', py: 6, position: 'static', marginTop: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              {t('app.name')}
            </Typography>
            <Typography variant="body2" color="grey.400">
              {t('app.description')}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              {t('common.quickLinks', 'Liens rapides')}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/" color="inherit" underline="hover">
                  {t('navigation.home')}
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/search" color="inherit" underline="hover">
                  {t('navigation.equipment')}
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/how-it-works" color="inherit" underline="hover">
                  {t('navigation.howItWorks')}
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/about" color="inherit" underline="hover">
                  {t('navigation.about')}
                </Link>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              {t('footer.legal', 'Légal')}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/terms" color="inherit" underline="hover">
                  {t('footer.termsOfUse', 'Conditions d\'utilisation')}
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/privacy" color="inherit" underline="hover">
                  {t('footer.privacyPolicy', 'Politique de confidentialité')}
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/cookies" color="inherit" underline="hover">
                  {t('footer.cookiePolicy', 'Politique de cookies')}
                </Link>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              Support
            </Typography>
            <Box sx={{ mb: 2 }}>
              <Link
                component="button"
                type="button"
                onClick={openHelp}
                color="inherit"
                underline="hover"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1,
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  textAlign: 'left'
                }}
              >
                <SupportAgentIcon fontSize="small" sx={{ mr: 1 }} />
                {t('common.contactSupport', 'Contacter le support')}
              </Link>
              <Typography variant="body2" color="grey.400" sx={{ mt: 1.2 }}>
                {t('footer.supportHelpDesc', 'Ouvrez l’aide pour consulter la FAQ ou créer une demande.')}
              </Typography>
            </Box>
            <Typography variant="subtitle2" gutterBottom>
              {t('footer.followUs', 'Suivez-nous')}
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton color="inherit" aria-label="Facebook" component="a" href="https://facebook.com" target="_blank">
                <FacebookIcon />
              </IconButton>
              <IconButton color="inherit" aria-label="Twitter" component="a" href="https://twitter.com" target="_blank">
                <TwitterIcon />
              </IconButton>
              <IconButton color="inherit" aria-label="Instagram" component="a" href="https://instagram.com" target="_blank">
                <InstagramIcon />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3, borderColor: 'grey.800' }} />
        
        <Typography variant="body2" color="grey.500" align="center">
          &copy; {currentYear} {t('app.name')}. {t('footer.allRightsReserved', 'Tous droits réservés.')}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;